import api from './api';

interface TurnoType {
  inicio: number;
  fim: number;
}

interface DisponibilidadeData {
  produto_id: number;
  role: {
    dias: {
      domingo: boolean;
      segunda: boolean;
      terca: boolean;
      quarta: boolean;
      quinta: boolean;
      sexta: boolean;
      sabado: boolean;
    };
    turnos?: TurnoType[];
  };
}

const newProdutoDisponibilidade = async ({
  produto_id,
  role,
}: DisponibilidadeData): Promise<void> => {
  await api.post('/produto/disponibilidade', {
    produto_id,
    ativo: true,
    role,
  });
};

export default newProdutoDisponibilidade;
